export default "__VITE_ASSET__BwnD0Xnk__"